import { useContext } from "react";
import "./style/index.scss";
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import { LandingScreen } from "./screens/LandingScreen";
import { observer } from "mobx-react";
import { PageContainer } from "./components/common/PageContainer/PageContainer";
import { AppContext } from "./index";
import { AboutYouScreen } from "./screens/AboutYouScreen";
import {
  ROOT_URL,
  LANDING_URL,
  ABOUT_YOU_URL,
  ABOUT_YOUR_LOAN_URL,
  THANK_YOU_URL,
  ASSERTION_URL,
  APPENDIX_URL,
  INIT_URL,
  REPAYMENT_HOLIDAY_ATTN_URL,
  YOUR_BOUNCE_BACK_LOAN_URL,
  REPAYMENT_HOLIDAY_ENTRY_URL,
  EXTEND_TERM_ENTRY_URL,
  REPAYMENT_HOLIDAY_SUMMARY_URL,
  EXTEND_TERM_SUMMARY_URL,
  EXTEND_TERM_ATTN_URL,
} from "App.const";
import { AboutYourLoanScreen } from "screens/AboutYourLoanScreen";
import { ThankYouScreen } from "screens/ThankYouScreen";
import { AssertionsScreen } from "screens/AssertionsScreen";
import { AppendixScreen } from "screens/AppendixScreen";
import { InitScreen } from "screens/InitScreen";
import { AppRoute } from "components/Route";
import { AttestationScreen } from "screens/Attestation";
import { YourBBLSScreen } from "screens/YourBBLSScreen";
import { RepaymentHoldidayScreen } from "screens/RepaymentHolidayScreen";
import { ExtendTermScreen } from "screens/ExtendTermScreen";
import { Menu } from "domain/menuOptions";
import { ApplicationSummaryScreen } from "screens/ApplicationSummaryScreen";
import { useFavIcon } from "util/favIcon";
import { ScrollToTop } from "components/ScrollToTop";
const AppRoutes = observer(() => {
  const store = useContext(AppContext);

  const RouterElements = useRoutes([
    {
      path: INIT_URL,
      element: <InitScreen store={store} />,
    },
    {
      element: <AppRoute />,
      children: [
        {
          path: ROOT_URL,
          element: <LandingScreen />,
        },
        {
          path: LANDING_URL,
          element: <LandingScreen />,
        },
        {
          path: ASSERTION_URL,
          element: <AssertionsScreen store={store} />,
        },
        {
          path: ABOUT_YOU_URL,
          element: <AboutYouScreen store={store} />,
        },
        {
          path: ABOUT_YOUR_LOAN_URL,
          element: <AboutYourLoanScreen store={store} />,
        },
        {
          path: YOUR_BOUNCE_BACK_LOAN_URL,
          element: <YourBBLSScreen store={store} />,
        },
        {
          path: REPAYMENT_HOLIDAY_ATTN_URL,
          element: (
            <AttestationScreen
              store={store}
              selectedMenu={Menu.RequestRepaymentHoliday}
            />
          ),
        },
        {
          path: EXTEND_TERM_ATTN_URL,
          element: (
            <AttestationScreen store={store} selectedMenu={Menu.ExtendTerm} />
          ),
        },
        {
          path: REPAYMENT_HOLIDAY_ENTRY_URL,
          element: <RepaymentHoldidayScreen store={store} />,
        },
        {
          path: REPAYMENT_HOLIDAY_SUMMARY_URL,
          element: (
            <ApplicationSummaryScreen
              store={store}
              treatmentOption={Menu.RequestRepaymentHoliday}
            />
          ),
        },
        {
          path: EXTEND_TERM_ENTRY_URL,
          element: <ExtendTermScreen store={store} />,
        },
        {
          path: EXTEND_TERM_SUMMARY_URL,
          element: (
            <ApplicationSummaryScreen
              store={store}
              treatmentOption={Menu.ExtendTerm}
            />
          ),
        },
        {
          path: APPENDIX_URL,
          element: <AppendixScreen store={store} />,
        },
        {
          path: THANK_YOU_URL,
          element: <ThankYouScreen store={store} />,
        },
      ],
    },
    {
      path: "*",
      element: <>Page Not Found</>,
    },
  ]);
  return RouterElements;
});

export const App = observer(() => {
  useFavIcon();
  window.addEventListener("unhandledrejection", (event) => {
    console.error("Unhandled promise rejection:", event.reason);
    console.error("Promise:", event.promise);
  });

  return (
    <PageContainer>
      <Router>
        <ScrollToTop />
        <AppRoutes />
      </Router>
    </PageContainer>
  );
});
